/* =====================================================================
   DIVIN Newsletter, partage par le footer, Divin · Counter Mail et Divin · Popup
   soumission AJAX sans reload, et neutralisation de la modale de succes native
   charge une fois par footer.liquid sur toutes les pages : rien a charger dans les sections
   delegation sur document en capture : survit au re-render du customizer
   SPEC: scope explicite aux 3 conteneurs et pas `.newsletter-form` tout court, un formulaire
   natif ailleurs garde sa modale
   destination Shopify par defaut, endpoint externe si le form porte data-divin-external
   ===================================================================== */
(function () {
  // (1) submit AJAX
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('.footer .newsletter-form form, .divin-counter .newsletter-form form, .divin-popup .newsletter-form form')) return;

    var host = form.closest('newsletter-form') || form.closest('.newsletter-form');
    // garde : deja envoye ou en cours, renvoi bloque, sinon un doublon Brevo par clic
    if (host && (host.classList.contains('newsletter-form--divin-success') || host.classList.contains('newsletter-form--divin-pending'))) {
      e.preventDefault();
      return;
    }

    var input = form.querySelector('input[type="email"], input[name="contact[email]"]');
    if (input && !input.checkValidity()) return; // NATIVE: laisse le natif afficher l'erreur
    e.preventDefault();

    var data = new FormData(form);
    // piege a robots : rempli = on n'envoie rien, et on affiche quand meme le succes
    var trap = data.get('email_address_check');
    var isBot = typeof trap === 'string' && trap !== '';

    // pending des le clic : bouton grise et garde armee ; a la reponse success remplace pending, garde et bouton restent bloques
    var btn = form.querySelector('button[type="submit"], .newsletter-form__button');
    if (host) host.classList.add('newsletter-form--divin-pending');
    if (btn) btn.disabled = true;
    var done = function () {
      if (host) {
        host.classList.remove('newsletter-form--divin-pending');
        host.classList.add('newsletter-form--divin-success');
      }
    };

    if (isBot) { done(); return; }

    // Endpoint externe, urlencoded + no-cors
    // prestataire sans en-tete CORS, reponse opaque : succes optimiste, comme cote Shopify
    // urlencoded et pas multipart : format attendu par Brevo
    var opts = form.hasAttribute('data-divin-external')
      ? { method: 'POST', mode: 'no-cors', body: new URLSearchParams(data) }
      : { method: 'POST', body: data, headers: { 'Accept': 'text/html' } };

    fetch(form.action, opts).then(done).catch(done);
  }, true);

  // (2) empeche l'ouverture de la modale native
  function neutralizeModal() {
    document.querySelectorAll('.footer .newsletter-form dialog, .divin-counter .newsletter-form dialog, .divin-popup .newsletter-form dialog').forEach(function (d) {
      try { if (d.open) d.close(); } catch (e) {}
      d.showModal = function () {};
      d.show = function () {};
    });
    document.querySelectorAll('.footer .newsletter-form dialog-component, .divin-counter .newsletter-form dialog-component, .divin-popup .newsletter-form dialog-component').forEach(function (dc) {
      dc.showDialog = function () {};
    });
  }

  if (document.readyState !== 'loading') neutralizeModal();
  else document.addEventListener('DOMContentLoaded', neutralizeModal);
  window.addEventListener('load', neutralizeModal);
  document.addEventListener('shopify:section:load', neutralizeModal); // re-render customizer
})();
